import React from 'react';
import { Link } from '../ui/link/Link';
import styles from './skip-link.scss';

export const SkipLink = props => {
  const handleKeyboard = e => {
    const { nativeEvent } = e;

    const { href } = nativeEvent.target;
    const keycode = nativeEvent.keyCode;

    if (keycode === 13 || keycode === 32) {
      // Enter or Space key
      nativeEvent.preventDefault();
      const hash = href.split('#')[1];
      const targetEl = document.querySelector(`#${hash}`);

      if (targetEl) {
        // Ensure the target element is focusable
        if (!targetEl.hasAttribute('tabindex')) {
          targetEl.setAttribute('tabindex', '-1');
        }

        // Webkit requires a timeout in order to shift focus
        window.setTimeout(() => {
          targetEl.scrollIntoView(true);
          targetEl.focus();
        }, 0);
      }
    }
  };

  return (
    <Link
      {...props}
      itemClassName={styles.skipLinkItem}
      anchorClassName={styles.skipLink}
      keyboardHandler={handleKeyboard}
    />
  );
};
